import { HttpClient, HttpParams } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { environment } from '../../../../../environments/environment';
import { PaginatedResponse } from '../../../../shared/interfaces/pagination';
import {
  DeeprootsFeedback,
  DeeprootsLinkSubmissionLog,
} from '../models/deeproots-log';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class DeeprootsLogsService {
  private http: HttpClient = inject(HttpClient);

  private adminApiBaseUrl = environment.apiBaseUrl + '/api/admin';

  getDeeprootsLinkSubmissionLogs(
    pageNo = 1,
    pageSize = 10,
    searchQuery?: string,
  ): Observable<PaginatedResponse<DeeprootsLinkSubmissionLog>> {
    let params = new HttpParams();
    params = params.set('page', pageNo.toString());
    params = params.set('page_size', pageSize.toString());

    if (searchQuery) {
      params = params.set('search_key', searchQuery);
    }

    return this.http.get<PaginatedResponse<DeeprootsLinkSubmissionLog>>(
      this.adminApiBaseUrl + '/connections/link/submissions',
      {
        params,
        headers: {
          'X-Skip-Loader': 'true',
        },
      },
    );
  }

  getDeeprootsFeedbacks(
    pageNo = 1,
    pageSize = 10,
    sortBy?: string,
  ): Observable<PaginatedResponse<DeeprootsFeedback>> {
    let params = new HttpParams();
    params = params.set('page', pageNo.toString());
    params = params.set('page_size', pageSize.toString());
    if (sortBy) {
      params = params.set('sort_by', sortBy);
    }

    return this.http.get<PaginatedResponse<DeeprootsFeedback>>(
      this.adminApiBaseUrl + '/feedbacks',
      {
        params,
        headers: {
          'X-Skip-Loader': 'true',
        },
      },
    );
  }
}
